import React, { useEffect, useState } from 'react';
import DoughnutChart from '../../common/donought_chart';
import BarChart from '../../common/bar_chart';
import { useTranslation } from 'react-i18next';
import { Breadcrumb, Button, Checkbox } from 'pepsico-ds';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLoading } from '../../loader';
import landingPageService from './landing_pageservice';
import ErrorFailOverHandler from '../../common/error_fail_over_handler';

const ChartsView = () => {
    const location = useLocation();
    const [pkiCertData, setPkiCertData] = useState([]);
    const { showLoader, hideLoader } = useLoading();
    const [showErrorPage, setShowErrorPage] = useState(false);
    const userData = JSON.parse(localStorage.getItem('okta-token-storage'));
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isTab, setIsTab] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setIsTab(window.innerWidth > 768 && window.innerWidth <= 1024);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getPkiCertificatesCount = async () => {
        try {
            showLoader();
            const response = await landingPageService.fetchPKICertificatesCount(userData?.accessToken?.claims?.gpid || "81200748");
            let certData = response?.response?.output?.[0]?.cert_data || [];
            if (certData.length === 0) {
                setPkiCertData([]);
                setShowErrorPage(true);
                hideLoader();
                return;
            }
            // [
            //     {
            //         "range": "90 - 61",
            //         "count": 282,
            //         "percentage": 78.33
            //     },
            //     {
            //         "range": "60 - 36",
            //         "count": 53,
            //         "percentage": 14.72
            //     },
            //     {
            //         "range": "35 - 16",
            //         "count": 17,
            //         "percentage": 4.72
            //     },
            //     {
            //         "range": "15 - 8",
            //         "count": 3,
            //         "percentage": 0.83
            //     },
            //     {
            //         "range": "7 - 1",
            //         "count": 5,
            //         "percentage": 1.39
            //     },
            //     {
            //         "range": "0",
            //         "count": 0,
            //         "percentage": 0.0
            //     }
            // ];
            const labels = certData.map(
                (x) => `Certificates expiring in ${x.range} days`
            );
            const maxLength = Math.max(...labels.map((l) => l.length));

            // ✅ pad with non-breaking spaces so chart legend aligns
            const paddedLabels = labels.map((l) =>
                l.padEnd(maxLength, "\u00A0")
            );

            // ✅ store in state with labels included
            setPkiCertData(
                certData.map((item, idx) => ({
                    ...item,
                    label: paddedLabels[idx]
                }))
            );
            hideLoader();
            console.log("PKI Certificates Count Response:", response);
        } catch (error) {
            console.error("Error fetching PKI certificates count:", error);
            setShowErrorPage(true);
            // const fallback = [
            //     { range: "90 - 61", count: 282, percentage: 78.33 },
            //     { range: "60 - 36", count: 53, percentage: 14.72 },
            //     { range: "35 - 16", count: 17, percentage: 4.72 },
            //     { range: "15 - 8", count: 3, percentage: 0.83 },
            //     { range: "7 - 1", count: 5, percentage: 1.39 },
            //     { range: "0", count: 0, percentage: 0.0 }
            // ];

            // const labels = fallback.map(
            //     (x) => `Certificates expiring in ${x.range} days`
            // );
            // const maxLength = Math.max(...labels.map((l) => l.length));
            // const paddedLabels = labels.map((l) =>
            //     l.padEnd(maxLength, "\u00A0")
            // );

            // setPkiCertData(
            //     fallback.map((item, idx) => ({
            //         ...item,
            //         label: paddedLabels[idx]
            //     }))
            // );
            hideLoader();
            return null;
        }
    };
    useEffect(() => {
        getPkiCertificatesCount();
    }, []);
    const pieData = {
        labels: pkiCertData?.map(x => x.range),
        datasets: [
            {
                label: 'Certificates expiring',
                data: pkiCertData?.map(x => x.count),
                // backgroundColor: '#33BFFF',
                borderRadius: 4,
                barThickness: 30,
                backgroundColor: [
                    '#33BFFF',
                    '#4BC0C0',
                    '#FFCE56',
                    '#FF6384',
                    '#9966FF',
                    '#36A2EB'
                ],
            }
        ],

    };

    const pieOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
                // position: 'top',
            },
            tooltip: { enabled: true },
            title: {
                display: true,
                text: 'Certificates expiring in next 90 days',
            },
            datalabels: {
                color: "black",
                anchor: "end",
                align: "top",
                font: {
                    weight: 'bold'
                },
                formatter: (value, context) => {
                    // `context.dataIndex` → index of the bar/pie slice
                    const item = pkiCertData[context.dataIndex];
                    return `${item.count} (${item.percentage}%)`;
                },
            }
        },
        onClick: (evt, activeEls, chart) => {
            if (activeEls.length > 0) {
                window.open('https://mycert-pepsico.appvx.com/appviewx/app#certificate/insights/summary', "_blank");
            }
        },
        layout: {
            padding: {
                top: 30
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: Math.max(...pkiCertData.map(x => x.count)) + 20,
                title: {
                    display: true,
                    text: 'Certificates expiring',
                    font: {
                        size: 14,
                        weight: 'bold'
                    }
                },
                ticks: {
                    stepSize: 5
                }
            },
            x: {
                title: {
                    display: true,
                    text: 'Days',
                    font: {
                        size: 14,
                        weight: 'bold'
                    }
                }
            }
        },
        maintainAspectRatio: false
    };

    const doughnutData = {
        labels: pkiCertData?.map((x) => x.label),
        datasets: [
            {
                label: 'Certificates expiring',
                data: pkiCertData?.map(x => x.count),
                backgroundColor: [
                    '#33BFFF',
                    '#4BC0C0',
                    '#FFCE56',
                    '#FF6384',
                    '#9966FF',
                    '#36A2EB'
                ],
                borderWidth: 1
            }
        ]
    };

    const doughnutOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
                align:'start',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth: 12,
                    textAlign:'left'
                    // padding: 20,

                    // font: {
                    //     size: 13
                    // }
                },
                onClick: (e) => {}
            },
            tooltip: {
                // callbacks: {
                //     label: (context) => {
                //         const label = context.label || '';
                //         const value = context.parsed || 0;
                //         return `${label}: ${value}`;
                //     }
                // }
                enabled: true
            },
            datalabels: {
                display: false,
            },
            layout: {
                padding: {
                    top: 20,
                    bottom: 40
                },
                margin: {
                    bottom: 20
                }
            },
            maintainAspectRatio: true
            // leftAlignedTitlePlugin

        },
        onClick: (evt, activeEls, chart) => {
            if (activeEls.length > 0) {
                window.open('https://mycert-pepsico.appvx.com/appviewx/app#certificate/insights/summary', "_blank");
            }
        }
    };

    const [checked, setChecked] = useState(
        doughnutData.labels.reduce((acc, label) => {
            acc[label] = false;
            return acc;
        }, {})
    );

    // Filter chart data based on checked boxes
    const filteredData = {
        labels: doughnutData.labels.filter((label) => checked[label]),
        datasets: [
            {
                ...doughnutData.datasets[0],
                data: doughnutData.datasets[0].data.filter((_, i) =>
                    checked[doughnutData.labels[i]]
                ),
                backgroundColor: doughnutData.datasets[0].backgroundColor.filter((_, i) =>
                    checked[doughnutData.labels[i]]
                ),
            },
        ],
    };

    const toggleCheckbox = (label) => {
        setChecked((prev) => ({ ...prev, [label]: !prev[label] }));
    };

    return (
        <>
            {showErrorPage ? (
                <ErrorFailOverHandler
                    header="Data not found"
                    title="Uh oh, we can’t seem to find the data you’re looking for."
                    supportMessage="Try going back or contact"
                    supportLabel="Support"
                    supportLink="mailto:DL-IAMCentralOperations@pepsico.com?subject=Support Request&body=Hello Team,"
                    alternateMessage="You can also complete tasks in myidM"
                    alternateLabel="Go to PKI Certificates"
                    alternateLink="https://mycert-pepsico.appvx.com/appviewx/app#certificate/insights/summary"
                    image="src/assets/error.png"
                />

            ) : (
                <div id='charts-view' style={{ margin: '0 16px' }}>
                    <Breadcrumb
                        homeIcon={{
                            icon: "home",
                            onClick:()=>{
                            navigate("/home")
                            }
                        }}
                        breadcrumbs={[
                            {
                                label: 'Home'
                            },
                            {
                                label: "Total number of Certificates expirings"
                            }
                        ]}
                        className=""
                        style={{}}
                    />
                    <div className={isMobile ? 'd-grid align-items-center' : 'd-flex justify-content-between align-items-center'}>
                        {/* <span className="page-header">Total number of Certificates expiring</span> */}
                        <div className="header-text-1 mb-2">{t("pki.total_number_of_certificates_expiring")}</div>
                        <Button variant='tertiary' text='View Certificates' className='btn-sm' onClick={() => window.open('https://mycert-pepsico.appvx.com/appviewx/app#certificate/insights/summary')} />
                    </div>
                    <div className='chart-container card' style={{ height: isMobile ? 'auto' : 'calc(100vh - 216px)', paddingBottom: isMobile ? '32px' : '16px', padding: '16px', alignItems: 'center', justifyContent: isMobile ? '' : 'center' }}>
                        <div style={{ display: isMobile ? 'grid' : 'flex', justifyContent: 'start', gap: (isMobile || isTab) ? '40px' : '100px', width: isTab ? '100%' : '100%' }}>
                            <div style={{ width: isMobile ? '100%' : '50%' }}>
                                <div className='chartsTitle mb-3' style={{ textAlign: isMobile ? 'center' : 'center' }}>
                                    {t("pki.certificates_expiring")}
                                </div>
                                {pkiCertData.length === 0 ? <div style={{ textAlign: 'center', marginTop: '100px', color: '#888' }}>{t("pki.no_data_available")}</div> : <BarChart data={pieData} height={'300px'} options={pieOptions} />}
                            </div>
                            {isMobile ? <hr className='custom-hr' style={{ border: '1px solid #a39f9f', margin: '0px' }} /> : null}
                            <div style={{ width: isMobile ? '100%' : '' }}>
                                <div className='chartsTitle mb-3' style={{ textAlign: isMobile ? 'center' : 'center' }}>
                                    {t("pki.expiring_certificates_inventory")}
                                </div>
                                {pkiCertData.length === 0 ? <div style={{ textAlign: 'center', marginTop: '100px', color: '#888' }}>{t("pki.no_data_available")}</div> : <DoughnutChart data={doughnutData} height={'330px'} options={{ ...doughnutOptions, cutout: '70%' }} />}

                                {/* {pkiCertData.length === 0 ? <div style={{ textAlign: 'center', marginTop: '100px', color: '#888' }}>No data available</div> :
                                    <div>
                                        <DoughnutChart data={doughnutData} height={'330px'} options={{ ...doughnutOptions, cutout: '70%', plugins: { legend: { display: false } } }} />
                                        <div style={{ marginTop: "1rem" }}>
                                            {doughnutData.labels.map((label, idx) => (
                                                <div key={label} style={{ marginBottom: "6px" }}>
                                                    <Checkbox
                                                        label=""
                                                        size="small"
                                                        onUpdate={(event) => {
                                                            toggleCheckbox(label);
                                                        }}
                                                        text={label}
                                                    />                                                    
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                } */}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ChartsView;
